import { Logger } from "@Shared/logger/logger";
import { LoggerService } from "@Shared/logger/logger.service";
import { UrlUtil } from "@Shared/utils";

import { AppleModule, BlueConicModule, Bus, EventModule, InitOptions, OptionsModule,EntitlementModule, EngageModule, OneTapModule, PageSuiteModule } from "@Modules/index";
import { AUTH0_CONST, AuthModule } from "@Modules/auth_module";
import { UIModule } from "@Modules/ui_module";
import { APP_EVENTS } from "@Core";





export class PluginClass{
    private Logger: Logger = LoggerService.createLogger("Plugin");
    
    constructor() {
        this.Logger.trace("****  CTOR ****");
        
    }

    public async init(opts: InitOptions): Promise<void> {
        this.Logger.trace("Plugin Initializing");
        try {

            const returnAfterLogout = UrlUtil.getQueryParam(AUTH0_CONST.returnAfterLogoutParam);
            if (returnAfterLogout) {
                this.Logger.trace("returnAfterLogout param present, redirecting", returnAfterLogout);
                window.location.assign(decodeURIComponent(returnAfterLogout));
                return;
            }

            //set performance tracking first so we can capture onInit event. We won't know if this is actually enabled when using config files from the server until after the OptionsModule is initialized .
            EventModule.setPerformanceTracking();
            Bus.emit(APP_EVENTS.onInit);
            await OptionsModule.init(opts);
            const options = OptionsModule.Options;
            const promises = [AuthModule.init(options.auth), UIModule.init(), EventModule.init(options.event), AppleModule.init()];

            if(OptionsModule.Options?.navigaOptions?.enable){
                promises.unshift(EngageModule.init(OptionsModule.Options.navigaOptions))
            }

            if(OptionsModule.Options?.pageSuiteOptions?.enable){
                promises.unshift(PageSuiteModule.init(OptionsModule.Options.pageSuiteOptions))
            }

            if(options.entitlement.check){
                this.Logger.debug("Entitlement Check Enabled...Initializing Entitlement Module");
                promises.push(EntitlementModule.init(options.entitlement));
            }

            if ( options.blueconic?.enabled ) {
                this.Logger.debug("BlueConic Enabled...Initializing BlueConic Module");
                promises.push( BlueConicModule.init( options.blueconic ) );
            }

            // Await here so callers of init() can rely on the returned promise to know when the modules are ready
            await Promise.all(promises)
            .then(() => {
                this.Logger.debug("Modules Initialized...Starting Pipeline");
                AuthModule.start();
                if (options.oneTapOptions?.enabled) {
                    OneTapModule.init(options.oneTapOptions).catch((err) => {
                        this.Logger.warn("One Tap init failed", err);
                    });
                }
            }).catch((error) => {
                //TODO: Implement the event bus with a fatal error that i'll handle things depending if i'm on pagesuite or not.
                this.Logger.error("Error initializing modules", error);

            }).finally(() => {
                this.Logger.trace("Plugin Initializing..Finally");

                //TODO: Need to implement logic on when this is called, based on init params like if we are checkingEntitlements or using Engage.
                Bus.emit(APP_EVENTS.onFinished);

            });
        } catch (error) {
            this.Logger.error(error);
            
        }
        
    }
    
}
